export default __webpack_public_path__ + "static/media/SHFA.9f5fc4b1.png";